var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShareGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 7.47198C16.1569 7.47198 17.5 6.12884 17.5 4.47198C17.5 2.81513 16.1569 1.47198 14.5 1.47198C12.8431 1.47198 11.5 2.81513 11.5 4.47198C11.5 6.12884 12.8431 7.47198 14.5 7.47198Z",
    fill: "#D5D5E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 18.528C16.1569 18.528 17.5 17.1849 17.5 15.528C17.5 13.8712 16.1569 12.528 14.5 12.528C12.8431 12.528 11.5 13.8712 11.5 15.528C11.5 17.1849 12.8431 18.528 14.5 18.528Z",
    fill: "#D5D5E3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 12.972C7.15685 12.972 8.5 11.6288 8.5 9.97198C8.5 8.31513 7.15685 6.97198 5.5 6.97198C3.84315 6.97198 2.5 8.31513 2.5 9.97198C2.5 11.6288 3.84315 12.972 5.5 12.972Z",
    fill: "#D5D5E3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.41 15.344L4.41002 10.844C4.09502 10.667 3.90002 10.333 3.90002 9.97198C3.90002 9.61098 4.09502 9.27798 4.41002 9.09998L12.41 4.59998L13.39 6.34298L6.94002 9.97198L13.391 13.599L12.41 15.344Z",
    fill: "#D5D5E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareGrey);
export default __webpack_public_path__ + "static/media/share_grey.40586ff8df2cecd5c8a27e6c2c77dd61.svg";
export { ForwardRef as ReactComponent };